import { ltjsModule } from '../ltjsEnvironment';
export function addActiveVisualization(manager) {
    ltjsModule.runtime.activeVisualizationManagers.add(manager);
}
export function removeActiveVisualization(manager) {
    ltjsModule.runtime.activeVisualizationManagers.delete(manager);
}
export function updateVisualizationSizes() {
    ltjsModule.runtime.activeVisualizationManagers.forEach(function (manager) {
        manager.sizeVisualization();
    });
}
export function getActiveVisualizationManagers() {
    return new Set(ltjsModule.runtime.activeVisualizationManagers);
}
